module.exports = __webpack_public_path__ + "img/catt2.66d7995d.png";